<template>
    <div>{{ msg }}</div>
</template>

<script>
export default {
    name: 'downloadProductList',
    data() {
        return {
            msg: ''
        };
    },

    mounted() {
        this.productExport();
    },
    created() {
        return {
            downloadWindow: null // 保存窗口引用
        };
    },
    methods: {
        // 商品清单
        productExport() {
            let loadingInstance = this.$loading(); // 显示 loading
            // 打开一个新窗口并保存引用
            this.downloadWindow = window.open('', '_blank');

            this.$newsApi
                .Product_List_Export()
                .then((res) => {
                    this.$closeLoading(loadingInstance); // 关闭 loading
                    if (res.data.Resultcode == 0) {
                        if (this.downloadWindow) {
                            // 设置新窗口的URL
                            this.downloadWindow.location.href = this.$fileUrl + res.data.data;
                            this.msg = '导出成功';
                            setTimeout(() => {
                                if (this.downloadWindow && !this.downloadWindow.closed) {
                                    this.downloadWindow.close();
                                }
                            }, 3000);
                            // 监听新窗口的unload事件（当下载开始时窗口会unload）
                            // 使用onload事件处理器而不是addEventListener
                            // this.downloadWindow.onload = () => {
                            //     // 延迟关闭以确保下载已经开始
                            //     this.msg = '导出成功';
                            //     setTimeout(() => {
                            //         if (this.downloadWindow && !this.downloadWindow.closed) {
                            //             this.downloadWindow.close();
                            //         }
                            //     }, 1000);
                            // };
                        } else {
                            this.downloadWindow.close();
                            // 如果窗口被拦截，提示用户
                            this.$message.error('下载窗口被浏览器拦截，请允许弹出窗口或手动复制链接下载。');
                            this.msg = '下载窗口被浏览器拦截，请允许弹出窗口或手动复制链接下载。';
                        }
                    }
                })
                .catch(() => {
                    this.$closeLoading(loadingInstance); // 关闭 loading
                    this.$message.error('导出失败');
                    this.msg = '下载窗口被浏览器拦截，请允许弹出窗口或手动复制链接下载。';
                    if (this.downloadWindow && !this.downloadWindow.closed) {
                        this.downloadWindow.close();
                    }
                });
        }
    }
};
</script>

<style>
</style>